import { FolderKind, IFolder } from "store/types";

import { useFolderHook } from "./use-folder-hook";

type DealFolderProp = Pick<IFolder, "id" | "deal_id" | "title" | "is_private" | "parent_id" | "user_id" | "kind">;

interface DealFolderHookParams {
  folder: {
    id: number;
    title: string;
    is_private: boolean;
    parent_id: number | null;
    user_id: number;
    kind: FolderKind;
    deal_id: number | null;
  };
  refetchHandler?: () => Promise<void>;
}

export const toDealFolderShape = (folder: IFolder): DealFolderProp => ({
  id: folder.id,
  title: folder.title,
  parent_id: folder.parent_id ?? null,
  deal_id: null,
  is_private: false,
  user_id: folder.user_id ?? -1,
  kind: "folder"
});

export const useClientFolderActions = ({ folder, refetchHandler }: DealFolderHookParams) => {
  const { onCreateNewFolder, onFileUpload, onDropFiles, onRenameFolder, onDeleteFolder } = useFolderHook({
    folder: { id: folder.id, title: folder.title, parent_id: folder.parent_id },
    refetchHandler
  });

  return {
    onCreateNewFolder,
    onFileUpload,
    onDropFiles,
    onRenameFolder,
    onDeleteFolder,
    onAddForm: undefined,
    onAddDocument: undefined,
    onShareDialog: undefined,
    onSetPrivate: undefined,
    checkOnSetPrivatePermission: () => false,
    onAddTask: undefined
  };
};
